import apiService from "./ApiService"
import { createQS } from "./Utils"

class CruzamentoService {
  async get(idContrato, termo, pagina) {
    try {
      const qs = createQS({ termo, pagina, idContrato })
      return await apiService.get(`cruzamento?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getByBBox(idContrato, minLat, maxLat, minLng, maxLng) {
    try {
      const bbox = [minLat, minLng, maxLat, maxLng].join(',')
      const qs = createQS({ bbox, idContrato })
      return await apiService.get(`cruzamento/bbox?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get(`cruzamento/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getCameras(id) {
    try {
      return await apiService.get(`cruzamento/${id}/cameras`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post(`cruzamento/`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put(`cruzamento/${id}`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete(`cruzamento/${id}`)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }    
}

const cruzamentoService = new CruzamentoService()
export default cruzamentoService